export class IndentHarvestingDateRangeReq {
    fromDate?: any;
    toDate?:any
    constructor(fromDate?: any,toDate?:any) {
        this.fromDate = fromDate
        this.toDate = toDate
    }
}